module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiv",
      "title": "iv"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "cover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Cover"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "tp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Titlepage"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Dedication"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnctf",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Introduction: Hello, Neighbor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_pn",
    attrs: {
      "id": "p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part001"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part I")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_pt"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part001"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Let’s Make the Most of This Beautiful Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_pn",
    attrs: {
      "id": "p2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Part II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_pt"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Ten Ways to Live More Like Mister Rogers Right Now")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The First Way: Be Deep and Simple.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Second Way: Be Kind to Strangers.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Third Way: Make a Joyful Noise.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Fourth Way: Tell the Truth.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c5"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/Ch005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Fifth Way: Connect with Other People Every Way You Can.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Sixth Way: Love Your Neighbors.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Seventh Way: Find the Light in the Darkness.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Eighth Way: Always See the Very Best in Other People.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Ninth Way: Accept the Changing Seasons.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_cnct",
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ch010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The Tenth Way: Share What You’ve Learned. (All Your Life.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bmf",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "src"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "also"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AlsoBy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Also by Gavin Edwards")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Atp",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 66
// module chunks = 0